<template>
<div id="progress">
  <transition name="fade">
  <div v-if="$route.name === 'Review' || $route.name === 'NextSteps' || $route.name === 'Download'" id="progress-bar" class="ff ff-align-between bg-dark-grey">
    <div 
      v-on:click="goBack"
      id="progress-back"
      class="btn bg-grey ff-center active"
    >
      <icon name="ui-chevron-left" color="white" size=18 />
      <span>Back</span> 
    </div>
    <div class="progress-bar-container ff ff-center">
      <div class="progress-bar-steps" :class="'progress-bar-total-'+progressBar.bar.steps.length">
        <div class="ff ff-nowrap">
          <div 
            v-for="(step, s) in progressBar.bar.steps" 
            class="progress-bar-step ff ff-center"
            :class="progressBar.bar.current === s ? 'active' : 'inactive'"
            :key="'step-'+s"
          >
            <h5>{{ s+1 }}<span class="ff-mobile-hide">. {{ step }}</span></h5>
          </div>
          <div class="progress-bar-pill" :style="'left:' + ((progressBar.bar.current / progressBar.bar.steps.length) * 100) + '%;'"></div>
        </div>
      </div>
    </div>
    <router-link 
      :to="progressBar.next" 
      id="progress-next"
      class="btn bg-cyan ff-center"
      :class="progressBar.next !== '' ? 'active' : 'inactive'"
      @click.native="trackClick('next')"
    >
      <span>Next</span>
      <icon name="ui-chevron-right" color="white" size=18 /> 
    </router-link>
  </div>
  </transition>
</div>
</template>

<script>
  export default {
    name: 'progressBar',
    computed: {
      apiURL() {
        return this.$store.state.apiURL;
      },
      progressBar() {
        var progressBar = {
          next: '',
          bar: {
            current: 0,
            steps: [
              'Review',
              'Next Steps'
            ]
          }
        };

        
        switch(this.$route.name) {
          case 'Review':
            progressBar.next = '/estimates/next-steps';
            progressBar.bar.current = 0;
            break;
            
          case 'NextSteps':
            progressBar.bar.current = 1;
            break;
            
          case 'Download':      
            progressBar.bar.current = 2;
            break;
            
        }
        
        if(this.$route.name === 'Download') {
          progressBar.bar.steps.push('Download');
        }
        
        return progressBar;
      }
    },
    methods: {
      goBack() {
        this.$router.go(-1);
        this.trackClick('back');
      },
      trackClick(btn) {
        this.$gtm.trackEvent({
          'event': 'review',
          'action': 'click',
          'button-name': btn
        });
      }
    }
  }
</script>